import React, { useState } from 'react';
import DateTime from 'react-datetime';
import moment from 'moment';
import loaderConnect from '../../../Components/Loader/loaderConnect';
import { apiGenPronosticosExcel, apiLoadPronosticosExcel } from '../../../lib/apiPaseLista';

// 🟢 1. Importar el nuevo componente (Ajusta la ruta según dónde lo hayas guardado)
import ConfiguracionPronosticos from './ConfiguracionPronosticos';

const PronosticosPaseLista = ({ showLoader }) => {
    // 🟢 2. Estado para manejar las pestañas
    const [activeTab, setActiveTab] = useState('formatos');

    // Estado para el rango de fechas de descarga/reporte
    const [dates, setDates] = useState({
        start_date: moment(),
        end_date: moment(),
    });

    // Estado para el archivo Excel que el usuario va a subir
    const [selectedFile, setSelectedFile] = useState(null);

    // Estado para mensajes de feedback (alertas de Bootstrap)
    const [mensaje, setMensaje] = useState({ type: '', text: '' });


    // Sincronización inteligente del rango de fechas
    const handleDateChange = (name, dateValue) => {
        if (!moment.isMoment(dateValue)) return;

        setDates((prevDates) => {
            const newDates = { ...prevDates, [name]: dateValue };

            if (name === 'start_date' && dateValue.isAfter(prevDates.end_date)) {
                newDates.end_date = dateValue;
            }
            if (name === 'end_date' && dateValue.isBefore(prevDates.start_date)) {
                newDates.start_date = dateValue;
            }

            return newDates;
        });
    };

    // DESCARGA DEL EXCEL DE PRONÓSTICOS
    const handleDownloadExcel = async () => {
        try {
            showLoader(true);
            setMensaje({ type: '', text: '' });

            const params = {
                fechaInicio: dates.start_date.format('YYYY-MM-DD'),
                fechaFin: dates.end_date.format('YYYY-MM-DD'),
            };

            const response = await apiGenPronosticosExcel(params);

            if (!response.ok) {
                throw new Error('No se pudo generar el archivo de pronósticos.');
            }

            const blob = await response.blob();
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `Pronosticos_${params.fechaInicio}_${params.fechaFin}.xlsx`);
            document.body.appendChild(link);
            link.click();
            link.remove();
        } catch (error) {
            console.error('Error al descargar el Excel:', error);
            setMensaje({
                type: 'danger',
                text: 'Ocurrió un error al generar el archivo de pronósticos.',
            });
        } finally {
            showLoader(false);
        }
    };

    // SUBIDA Y CARGA DEL EXCEL PRELLENADO
    const handleUploadExcel = async () => {
        if (!selectedFile) {
            setMensaje({ type: 'warning', text: 'Por favor selecciona un archivo Excel (.xlsx).' });
            return;
        }

        try {
            showLoader(true);
            setMensaje({ type: '', text: '' });

            const formData = new FormData();
            formData.append('archivo', selectedFile);

            const data = await apiLoadPronosticosExcel(formData);

            if (data && data.success) {
                setMensaje({
                    type: 'success',
                    text: data.mensaje || '¡Los pronósticos se cargaron y actualizaron con éxito!',
                });
                setSelectedFile(null);
            } else {
                throw new Error(data.error || 'Ocurrió un problema durante la importación.');
            }
        } catch (error) {
            console.error('Error al subir el Excel:', error);
            setMensaje({
                type: 'danger',
                text: error.message || 'Ocurrió un error al procesar el archivo capturado.',
            });
        } finally {
            showLoader(false);
        }
    };

    return (
        <div>
            <div className="page-title mb-3">
                <h3>
                    <i className="fas fa-clipboard-list" /> Pase de lista - Pronósticos
                </h3>
            </div>

            {/* 🟢 3. MENÚ DE PESTAÑAS TIPO SWITCH */}
            <div className="mb-4">
                <div
                    className="d-inline-flex p-1 rounded shadow-sm"
                    style={{ backgroundColor: "#e2e6ea" }}
                >
                    <button
                        className={`btn border-0 font-weight-bold px-4 py-2 m-0 ${activeTab === "formatos" ? "bg-white text-primary shadow-sm" : "text-muted bg-transparent"
                            }`}
                        style={{ borderRadius: "0.3rem", transition: "all 0.2s ease-in-out", outline: "none" }}
                        onClick={() => setActiveTab("formatos")}
                    >
                        <i className="fas fa-file-excel mr-2" />
                        Generar Formato
                    </button>

                    <button
                        className={`btn border-0 font-weight-bold px-4 py-2 m-0 ${activeTab === "configuracion" ? "bg-white text-primary shadow-sm" : "text-muted bg-transparent"
                            }`}
                        style={{ borderRadius: "0.3rem", transition: "all 0.2s ease-in-out", outline: "none" }}
                        onClick={() => setActiveTab("configuracion")}
                    >
                        <i className="fas fa-cogs mr-2" />
                        Configurar Actividades
                    </button>
                </div>
            </div>

            {/* 🟢 4. CONTENIDO: FORMATOS EXCEL (Tu código original) */}
            {activeTab === 'formatos' && (
                <div className="tab-pane fade show active">
                    {mensaje.text && (
                        <div className={`alert alert-${mensaje.type} alert-dismissible fade show`} role="alert">
                            {mensaje.text}
                            <button
                                type="button"
                                className="close"
                                onClick={() => setMensaje({ type: '', text: '' })}
                            >
                                <span>&times;</span>
                            </button>
                        </div>
                    )}

                    {/* SECCIÓN 1: DESCARGA DEL EXCEL */}
                    <div className="card bg-card-violet mb-4">
                        <div className="card-body">
                            <h5 className="mb-3">
                                <i className="fas fa-file-download mr-2" /> 1. Descargar Formato de Pronósticos
                            </h5>
                            <div className="row align-items-end">
                                <div className="col-md-4">
                                    <label>Fecha Inicio:</label>
                                    <DateTime
                                        closeOnSelect
                                        dateFormat="DD/MMM/YYYY"
                                        timeFormat={false}
                                        value={dates.start_date}
                                        onChange={(date) => handleDateChange('start_date', date)}
                                        locale="es"
                                        inputProps={{
                                            required: true,
                                            className: 'form-control',
                                            readOnly: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md-4">
                                    <label>Fecha Fin:</label>
                                    <DateTime
                                        closeOnSelect
                                        dateFormat="DD/MMM/YYYY"
                                        timeFormat={false}
                                        value={dates.end_date}
                                        onChange={(date) => handleDateChange('end_date', date)}
                                        locale="es"
                                        inputProps={{
                                            required: true,
                                            className: 'form-control',
                                            readOnly: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md-4 mt-3 mt-md-0">
                                    <button
                                        type="button"
                                        className="btn btn-primary btn-block"
                                        onClick={handleDownloadExcel}
                                    >
                                        <i className="fas fa-download mr-2" /> Descargar Excel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* SECCIÓN 2: CARGA / UPSERT DEL EXCEL CAPTURADO */}
                    <div className="card">
                        <div className="card-body">
                            <h5 className="mb-3">
                                <i className="fas fa-file-upload mr-2" /> 2. Cargar Pronósticos Capturados
                            </h5>
                            <p className="text-muted small">
                                Sube el archivo Excel con los jornales y horas extra capturados. Si ya existían datos
                                registrados en el sistema para ese rango de fechas y cultivos, se actualizarán
                                automáticamente con la información más reciente sin perder su costo histórico.
                            </p>

                            <div className="row align-items-center">
                                <div className="col-md-8">
                                    <div className="custom-file">
                                        <input
                                            type="file"
                                            className="custom-file-input"
                                            id="customFileLang"
                                            accept=".xlsx, .xls"
                                            onChange={(e) => setSelectedFile(e.target.files[0] || null)}
                                        />
                                        <label className="custom-file-label" htmlFor="customFileLang">
                                            {selectedFile ? selectedFile.name : 'Seleccionar archivo Excel...'}
                                        </label>
                                    </div>
                                </div>

                                <div className="col-md-4 mt-3 mt-md-0">
                                    <button
                                        type="button"
                                        className="btn btn-success btn-block"
                                        onClick={handleUploadExcel}
                                        disabled={!selectedFile}
                                    >
                                        <i className="fas fa-upload mr-2" /> Subir y Procesar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* 🟢 5. CONTENIDO: CONFIGURACIÓN */}
            {activeTab === 'configuracion' && (
                <div className="tab-pane fade show active">
                    <ConfiguracionPronosticos />
                </div>
            )}
        </div>
    );
};

export default loaderConnect(PronosticosPaseLista);